import { observable, action, runInAction, makeObservable } from 'mobx';

import { StoreExt, Loading } from '@utils/reactExt';

export class ElectronStore extends StoreExt {
    constructor() {
        super();
        makeObservable(this);
    }

    @observable
    info?: IElectronStore.IElectronStartRes;

    @Loading
    @action
    async start(): Promise<IElectronStore.IElectronStartRes> {
        try {
            const res = await this.$api.task.electronStart();
            runInAction(() => {
                this.info = res;
            });
            return res;
        } catch (error) {
            return Promise.reject(error);
        }
    }
}

export default new ElectronStore();
